<app-frame
  [title]="'Choose Admin PIN'"
  (back)="onBack()"
>
  <!-- H1 -->
  <span  class="e174_22">Choose a 4-digit admin PIN.</span>

  <app-pin-entry
    (enter)="onSubmit($event)"
  >

  </app-pin-entry>
</app-frame>
